export default el => {
  if (!el) return

  const parents = []
  while (el) {
    parents.unshift(el)
    el = el.parentNode
  }
  return parents
}



// WEBPACK FOOTER //
// ./src/utils/dom-parents.js